import { sendPasswordResetEmail } from 'firebase/auth';
import { auth } from './firebase';
import { getRuntimeConfig } from './runtimeConfig';
import { ServerURI } from '../globals';

export const PASSWORD_RESET_ACCEPTED = 'If this address is eligible, you will receive password-reset instructions.';
const origins = ['https://dev.featherglass.com', 'https://featherglass-dev-838082890481.us-central1.run.app'];

export async function requestPasswordReset(email) {
  const config = getRuntimeConfig({ throwOnInvalid: true });
  if (!config || (auth.app?.options?.projectId && auth.app.options.projectId !== config.firebase?.projectId)) {
    throw new Error('Password reset is unavailable.');
  }
  if (config?.firebase?.projectId !== 'featherglass-dev-2026') {
    // Keep the existing shared-project Local/Dev/Staging/Secure delivery path.
    await sendPasswordResetEmail(auth, email);
    return 'Password reset email sent! Please check your inbox and follow the instructions to reset your password.';
  }
  if (config.appEnv !== 'dev' || !origins.includes(config.appUrl) || config.apiBaseUrl !== config.appUrl || ServerURI !== config.apiBaseUrl) {
    throw new Error('Password reset is unavailable.');
  }
  let response;
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 10000);
  try {
    response = await fetch(`${config.apiBaseUrl}/api/auth/password-reset`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      credentials: 'omit', cache: 'no-store', redirect: 'error', body: JSON.stringify({ email }),
      signal: controller.signal,
    });
    if (response.status === 202 && (await response.json()).accepted === true) return PASSWORD_RESET_ACCEPTED;
  } catch { /* Never echo server bodies or provider/action-link errors. */ }
  finally { clearTimeout(timer); }
  const error = new Error('Unable to request password reset. Please try again later.');
  if (response?.status === 429) error.code = 'auth/too-many-requests';
  throw error;
}
